
import { Component, Vue } from 'vue-property-decorator';
import { namespace, Action } from 'vuex-class';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

const user = namespace('user');
UIkit.use(Icons);

@Component({
  name: 'App',
})
export default class App extends Vue {
  @user.Action('setLoginData') setLoginData: (token: string) => void;
  @user.Action('refreshJWT') refreshJWT: () => Promise<void>;

  @user.State('user') user;

  @user.Getter
  CASLUser;

  async created() {
    this.$i18n.locale = navigator.language?.substring(0, 2);
    //this.$router.replace({params: {lang: this.$i18n.locale}});

    /*const token = localStorage.getItem('authtoken');
    return;
    if (!token) {
      return;
    }
    this.setLoginData(token);
    */
    //this.refreshJWT().catch(err => this.$router.push({name: 'login'}));

    /*if (this.user) {
      this.$ability.update(createForUser(this.CASLUser).rules);
    }*/
  }
}
